import React from 'react';
import clsx from 'clsx';
import { TypedMemo } from '../../../../common/types';
/* eslint-disable css-modules/no-unused-class -- one stylesheet for the lyric timing; each part uses its own slice of it */
import styles from './LyricTiming.module.scss';
/* eslint-enable css-modules/no-unused-class */

export type LyricTimingPillTone = 'ok' | 'run' | 'bad' | 'off';

const TONE_CLASS: Record<LyricTimingPillTone, string | undefined> = {
  ok: styles.pillOk,
  run: styles.pillRun,
  bad: styles.pillBad,
  off: styles.pillOff,
};

interface LyricTimingPillProps {
  tone: LyricTimingPillTone;
  label: string;
}

/** The state pill of the lyric timing (design s8b): green Synced, violet Syncing, red Failed, grey. */
const LyricTimingPillComponent: React.FC<LyricTimingPillProps> = ({ tone, label }) => (
  <span className={clsx(styles.pill, TONE_CLASS[tone])}>{label}</span>
);

export const LyricTimingPill = TypedMemo(LyricTimingPillComponent);
